module.exports = {
      id: "instagram-square-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-61dfca8afc3dd3934ecf034e99eaf2c3.svg#instagram-square",
      toString: function () {
        return this.url;
      }
    }